import {API, Setup} from '../../Services';


async function StoreData(){
    let token =  localStorage.getItem('token');
    let mallId =  localStorage.getItem('mallId');
    return API.get(`/malls/${mallId?mallId:Setup.default_malls}/merchants`,{ headers: { 'Authorization':  `Bearer ${token}`} });
}


async function StoreDataMallAccount(){
    let token =  localStorage.getItem('token');
    let mallId =  localStorage.getItem('mallId');
    return API.get(`/malls/${mallId?mallId:Setup.default_malls}/mall-account-merchant?is_mall_account=true`,{ headers: { 'Authorization':  `Bearer ${token}`} });
}


async function CatData(){
    let token =  localStorage.getItem('token');
    let mallId =  localStorage.getItem('mallId');
    return API.get(`/malls/${mallId?mallId:Setup.default_malls}/categories`,{ headers: { 'Authorization':  `Bearer ${token}`} });
}


export {StoreData,CatData,StoreDataMallAccount};
